import React from "react";
import { motion } from "framer-motion";
import { pageVariants } from "../animations/pageTransitions";
import "./Capabilities.css";
import primary from "../../practices_images/primary-care.jpg";
import CollapsibleSection from "./CollapsibleSection"; // adjust path if needed

const PrimaryCare = () => {
  return (
    <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
      <div className="cap-container">
        <h1>Primary Care</h1>

        <div className="cap-section">
          <div className="text-content">
            {/* ✅ First 2 sections: normal (always visible) */}
            <h3>Strengthening the Foundation of Healthcare</h3>
            <p>
              Primary care is where healthcare begins and where operational complexity is often greatest.
              As patient volumes increase, regulations evolve, and financial pressure grows, practices must
              balance high quality care with efficient and compliant operations.
            </p>
            <p>
              We work alongside primary care leaders to bring clarity to complex environments. Our focus is on helping practices operate with confidence so clinicians and staff can concentrate on delivering care.
            </p>

            <h3>The Challenge Facing Primary Care</h3>
            <p>
              Primary care practices operate at the intersection of access, quality, and cost. Administrative demands continue to rise while reimbursement models and compliance requirements become more complex. Staffing constraints and technology inefficiencies add further strain.
            </p>
            <p>
              These challenges are interconnected. Addressing one in isolation rarely creates lasting improvement. Sustainable progress requires a coordinated and practical approach.
            </p>

            {/* ✅ Everything after: collapsible */}
            <CollapsibleSection title="Our Role">
              <p>
                We support primary care practices by aligning operations, financial processes, and technology with the realities of day to day care delivery.
              </p>
              <p>
                Our work focuses on improving workflows across clinical and administrative teams, strengthening documentation and billing accuracy, supporting effective use of EMR systems, and reinforcing compliance and reporting processes. Each engagement is tailored to the structure and maturity of the practice.
              </p>
            </CollapsibleSection>

            <CollapsibleSection title="Creating Clarity and Stability">
              <p>
                Our goal is not disruption. It is steady, measurable improvement.
              </p>
              <p>
                By simplifying operations and reinforcing financial foundations, we help practices operate more efficiently, improve revenue predictability, reduce administrative burden, and create a better experience for both patients and care teams.
              </p>
              <p>
                The result is an organization that is better prepared to adapt, grow, and remain resilient in a changing healthcare environment.
              </p>
            </CollapsibleSection>

            <CollapsibleSection title="Who We Work With">
              <p>
                We partner with independent primary care practices, multi provider clinics, and growing groups that are navigating operational complexity, financial pressure, or preparing for the next stage of growth.
              </p>
            </CollapsibleSection>

            <CollapsibleSection title="Looking Ahead">
              <p>
                Primary care will continue to evolve. Strong operational and financial fundamentals remain essential.
              </p>
              <p>
                We help practices build those fundamentals with discipline, transparency, and purpose.
              </p>
              <p>
                Let’s start a conversation about where your practice is today and how it can move forward with clarity.
              </p>
            </CollapsibleSection>
          </div>

          <div className="image-container">
            <img src={primary} alt="Primary Care" />
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default PrimaryCare;
